<template>
    <div>
        <v-dialog v-model="isOpen" persistent max-width="400px"> 
            <v-card>
          <v-card-title>
            <span>Введите название новой папки</span>
            <v-spacer></v-spacer>
            
          </v-card-title>
          <v-container fluid>
          <v-layout row>
                <v-flex xs12>
                    <v-text-field
                    required
                    id="testing"
                    name="input-1"
                    label="Название папки"
                    v-model="folderName"
                    autofocus
                    @keyup.enter="closeDialog(true)"
                    ></v-text-field>
                </v-flex>
            </v-layout>
          </v-container>
          <v-card-actions>
            <v-btn color="primary" flat @click.stop="closeDialog(true)">Ок</v-btn>
            <v-btn color="primary" flat @click.stop="closeDialog(false)">Отменить</v-btn>
          </v-card-actions>
        </v-card>
        </v-dialog>
    </div>
</template>
<script>
export default {
    props: {
        isOpen: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            folderName: ''
        }
    },
    methods: {
        closeDialog($event) {
            this.$emit('close-dialog', {folderName: this.folderName, create: $event})
            this.folderName = ''
        }
    }
}
</script>

